// extracted by mini-css-extract-plugin
export var checked = "loader-module--checked--b3fe3";
export var circle = "loader-module--circle--82377";
export var loader = "loader-module--loader--09b93";
export var loaderFixed = "loader-module--loader-fixed--6b4aa";
export var noDimension = "loader-module--noDimension--f2702";
export var rotate = "loader-module--rotate--6bd2c";
export var unchecked = "loader-module--unchecked--d17a2";